import * as Sentry from '@sentry/react'
import { ErrorState } from './ErrorState'

interface SentryErrorBoundaryProps {
  children: React.ReactNode
}

export function SentryErrorBoundary({ children }: SentryErrorBoundaryProps) {
  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <ErrorState
          message="Ha ocurrido un error inesperado."
          onRetry={resetError}
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  )
}
